import React, { useEffect } from 'react';
import { MenuComponent } from '../../../../rbts/assets/ts/components';
import { TableList, LoadingGrid } from '../../../../rbts/helpers';

type Props = {
  data: any;
  onEditRegister: (row: any) => void;
  loadingGrid: boolean;
};

const ListGrid: React.FC<Props> = ({ data, onEditRegister, loadingGrid }) => {
  const columns: any = [
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Nombre</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => (
        <>
          <span className="fw-bolder ">{row.nombre}</span>
        </>
      ),
      sortable: true,
      width: '30%',
    },
    {
      id: 'nombre_contacto',
      name: <div className="fw-bolder text-muted me-5">Nombre contacto</div>,
      selector: (row: any) => row.nombre_contacto,
      cell: (row: any) => (
        <>
          <span className="fw-bolder ">{row.nombre_contacto}</span>
        </>
      ),
      sortable: true,
      width: '30%',
    },
    {
      id: 'telefono',
      name: <div className="fw-bolder text-muted me-5">Teléfono</div>,
      selector: (row: any) => row.telefono,
      cell: (row: any) => (
        <>
          <span className="fw-bolder ">{row.telefono}</span>
        </>
      ),
      sortable: true,
      width: '30%',
    },
    {
      name: <div className="fw-bolder text-muted me-5">Acciones</div>,
      cell: (row: any) => dropdownRender(row),
      sortable: true,
      width: '10%',
    },
  ];

  const dropdownRender = (row: any) => {
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <div
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </div>
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <div
                className="menu-link px-3"
                onClick={() => {
                  onEditRegister(row.id);
                }}
              >
                Editar
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  // MenuComponent.reinitialization();

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [loadingGrid]);

  return (
    <>
      {loadingGrid ? (
        <LoadingGrid text="Cargando..."></LoadingGrid>
      ) : (
        <TableList data={data} columns={columns}></TableList>
      )}
    </>
  );
};

export { ListGrid };
